import { __exportAll } from "../../../../_virtual/_rolldown/runtime.js";
import { parseFactory } from "../../../../validators/parse.js";
import { z } from "zod";
//#region src/central/v3/users/get/by-id.ts
var by_id_exports = /* @__PURE__ */ __exportAll({
	ResponseSchema: () => ResponseSchema,
	parse: () => parse
});
var Contact = z.object({
	first: z.string(),
	last: z.string(),
	mobile: z.string(),
	primaryContact: z.boolean(),
	sendBillingAlerts: z.boolean(),
	sendStreamingAlerts: z.boolean(),
	title: z.string()
});
var ResponseSchema = z.object({
	active: z.boolean(),
	address: z.string().nullable(),
	contact: Contact.nullable(),
	emailVerified: z.boolean(),
	locked: z.boolean(),
	passwordResetRequired: z.boolean(),
	userName: z.string(),
	userPlanId: z.string(),
	userPlanName: z.string(),
	uuid: z.string()
});
var parse = parseFactory(ResponseSchema);
//#endregion
export { by_id_exports };

//# sourceMappingURL=by-id.js.map